import { FieldInitialValue, IConfigMode, ValidationRule } from "./formTypes"

export enum InputFieldType {
    TEXT_FIELD = 'textField',
    AUTOCOMPLETE = 'autocomplete',
    SELECT = 'select',
    COMPONENT = 'component',
    NUMBER = 'number',
    BUTTON = 'button',
    LABEL = 'label',
    TOOGLE = 'toogle',
    TEXT = 'text'
}

export enum InputDataType {
    TEXT = 'text',
    NUMBER = 'number',
    BOOLEAN = 'boolean'
}

interface IFieldBase {
    key: string;
    name: string;
    initialValue?: FieldInitialValue
    valueType?: "string" | "number" | "boolean" | "array"
    label?: string;
    placeholder?: string;
    active?: boolean;
    description?: string;
    rules?: Record<string, unknown>;
    type?: string;
    dimensionId?: number;
    selectValues?: Array<{
        label: string;
        value: string;
        isPrefilled: boolean;
    }>;
}

interface IDynamicInputField {
    allowFreeText?: boolean;
    searchQuery?: ISearchQuery;
    isRequired?: boolean;
    isMultiline?: boolean;
    mode?: IConfigMode;
    data?: InputDataType.TEXT | InputDataType.NUMBER | InputDataType.BOOLEAN;
    predefined?: {
        text?: string;
        value?: string
    };
    maxValue?: number;
    validations?: ValidationRule[];
    name?: string;
    fields?: Array<{
        label: string;
        inputField: {
            type: InputFieldType.TEXT;
            isMandatory: boolean;
            maxLenght: number;
        };
    }>;
}

export interface ISearchQuery {
    name: string;
    params?: Record<string, string | number>;
}

interface ITextFieldConfig extends IFieldBase {
    inputField: IDynamicInputField & {
        type: InputFieldType.TEXT_FIELD;
    };
}

export interface IAutocompleteConfig extends IFieldBase {
    inputField: IDynamicInputField & {
        type: InputFieldType.AUTOCOMPLETE;
    };
}

interface ISelectConfig extends IFieldBase {
    inputField: IDynamicInputField & {
        type: InputFieldType.SELECT;
    };
}

interface IComponentConfig extends IFieldBase {
    inputField: IDynamicInputField & {
        type: InputFieldType.COMPONENT;
    };
}

interface INumberConfig extends IFieldBase {
    inputField: IDynamicInputField & {
        type: InputFieldType.NUMBER;
    };
}

interface IButtonConfig extends IFieldBase {
    inputField: IDynamicInputField & {
        type: InputFieldType.BUTTON;
    };
}

interface ILabelConfig extends IFieldBase {
    inputField: IDynamicInputField & {
        type: InputFieldType.LABEL;
    };
}

interface IToggleConfig extends IFieldBase {
    inputField: IDynamicInputField & {
        type: InputFieldType.TOOGLE;
    };
}

interface IAccountingDimensionConfig extends IFieldBase {
    inputField: IDynamicInputField & ITextFieldConfig['inputField'] | IDynamicInputField & IAutocompleteConfig['inputField'];
}

export type IConfigField =
    | ITextFieldConfig
    | IAutocompleteConfig
    | ISelectConfig
    | IComponentConfig
    | INumberConfig
    | IButtonConfig
    | ILabelConfig
    | IToggleConfig
    | IAccountingDimensionConfig;
